<script lang="ts">
  import { recommendation } from "../../../../stores/recommendation"
  import { ENV } from "../../../../util/env"

  import Text from "../../components/Text.svelte"
  import Title3 from "../../components/Title3.svelte"

  export let imageSrc = ""
  export let title = ""
  export let description = ""

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: details = $recommendation.details

  // $: baseUrl = `https://dev-media.gethumankind.com/${details.brand.id}/assets/css`
  $: baseUrl = details
    ? `${ENV.MEDIA_SERVICE_URL}/${details.brand.id}/assets/images`
    : undefined
</script>

<div class="container">
  <img src="{baseUrl}/{imageSrc}" alt={title} />
  <div class="text-wrapper">
    <Title3>{title}</Title3>
    <Text>{description}</Text>
  </div>
</div>

<style lang="scss">
  div.container {
    margin-bottom: 36px;
  }

  img {
    width: calc(100vw - 40px);
    height: calc(100vw - 40px);
    vertical-align: middle;
    margin-bottom: 20px;
  }

  div.text-wrapper {
    padding-right: 32px;
  }

  @media (min-width: 768px) {
    div.container {
      flex: 1;
      margin-bottom: 0;
    }

    img {
      width: 100%;
      height: auto;
    }

    div.text-wrapper {
      padding-right: 40px;
    }
  }
</style>
